export const ADJUSTMENT_TYPE_VOUCHER = 1;
export const ADJUSTMENT_TYPE_REFUND = 2;

export interface AdjustmentTypeOption {
  id: number;
  name: string;
}

export interface LegalEntityOption {
  id: number;
  name?: string;
  dataAreaId: string;
  outboundQueue?: string;
}

export interface CurrencyOption {
  id: number;
  code: string;
  currencyName?: string;
}

export interface InvoiceOption {
  id: number;
  legalEntityId?: number | null;
  recordLocator?: string;
  invoiceGroup?: string;
  issueDate?: string;
}

export interface BookingOption {
  id: number;
  currencyId?: number;
  itinerary?: string;
  carrier?: string;
  totalFare?: number;
  recordLocator?: string;
}

export interface SimulateErpLineRequest {
  adxBookingId: number | null;
  itemNumber: string | null;
  costPrice: number;
  salesPrice: number;
  costCurrency: string;
  salesCurrency: string;
}

export interface SimulateErpResponseRequest {
  adxInvoiceId: number;
  legalEntityId: number;
  adxInvoiceErpAdjustmentTypeId: number;
  rawText: string;
  pnr: string | null;
  lines: SimulateErpLineRequest[];
}

export interface SimulateErpResponseResult {
  adxInvoiceErpResponseId: number;
  adxInvoiceErpAdjustmentIds: number[];
  publishSkipped: boolean;
}
